import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { createToggleSlice, ToggleSlice } from "./toggle/toggleSlice";
import { createScrollModalSlice, ScrollModalSlice } from "./modal/scrollModalSlice";

// Combined app state with both slices
type AppState = ToggleSlice & ScrollModalSlice;

// Create the store with both slices
export const useAppStore = create<AppState>()(
  devtools((set, get, api) => ({
    ...createToggleSlice(set, get, api),
    ...createScrollModalSlice(set, get, api),
  }))
);